export default {
  data() {
    return {
      flashMessageTitle: '',
      flashMessageBody: '',
      flashMessageType: ''
    }
  },
  computed: {
    showFlashMessage() {
      const self = this;
      return !!(self.flashMessageType && self.flashMessageBody && self.flashMessageTitle);
    }
  },
  mounted()
  {
    const self = this;
    self.getMessageDataFromStore();
    self.getMessageDataFromUrl();
  },
  methods: {
    getMessageDataFromStore()
    {
      const self = this;
      if (self.$store.state.flashMessage && self.$store.state.flashMessage.body) {
        self.flashMessageBody = self.$store.state.flashMessage.body;
        self.flashMessageTitle = self.$store.state.flashMessage.title;
        self.flashMessageType = self.$store.state.flashMessage.type;
        self.$store.commit('setFlashMessage',{});
      }
    },
    getMessageDataFromUrl() {
      const self = this;
      let query = window.location.search;
      if (!query) {
        const hash = window.location.hash;
        query = hash.substr(hash.indexOf('?'));
      }
      const urlParams = new URLSearchParams(query);
      if (urlParams.has('flashMessageBody')) {
        self.flashMessageBody = urlParams.get('flashMessageBody');
      }
      if (urlParams.has('flashMessageTitle')) {
        self.flashMessageTitle = urlParams.get('flashMessageTitle');
      }
      if (urlParams.has('flashMessageType')) {
        self.flashMessageType = urlParams.get('flashMessageType');
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/FlashMessageMixin/index.js